"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * @Author: edvardchen
 * @Date:   2016-10-23 14:54:14
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2016-12-08 21:07:31
 */

var ARTICLE_SINGLE = exports.ARTICLE_SINGLE = 3;
var VIDEO_SINGLE = exports.VIDEO_SINGLE = 2;
var GALLERY = exports.GALLERY = 1;
var NORMAL = exports.NORMAL = 0;